import React from "react";

export const UnitBlockingRequestIcon = () => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_243_2344)">
      <circle cx="25.3999" cy="21.9191" r="21" fill="#31D483" />
    </g>
    <g clip-path="url(#clip0_243_2344)">
      <path
        d="M36.4862 14.8343C36.0348 12.7962 34.059 10.9291 32.0153 10.5326C30.7703 10.2837 27.2969 9.97615 24.9995 10.0015C22.7022 9.97615 19.2287 10.2837 17.9837 10.5326C15.94 10.9291 13.9642 12.7962 13.5128 14.8343C13.2559 16.0718 13.0033 17.7555 12.9995 20.0538C13.0033 22.3521 13.2559 24.0354 13.5128 25.2729C13.9642 27.311 15.94 29.178 17.9837 29.5746C18.6559 29.7091 19.9778 29.8605 21.4136 29.9674C21.5762 30.2229 21.7525 30.4947 21.9433 30.783C22.705 31.9366 23.2881 32.7405 23.7297 33.3007C24.4647 34.233 25.5348 34.233 26.2698 33.3007C26.7114 32.7405 27.294 31.9366 28.0562 30.783C28.247 30.4943 28.4228 30.2229 28.5859 29.9674C30.0217 29.8605 31.3436 29.7091 32.0162 29.5746C34.06 29.178 36.0358 27.311 36.4872 25.2729C36.744 24.0354 36.9967 22.3521 37.0005 20.0538C36.9967 17.7555 36.744 16.0722 36.4872 14.8347L36.4862 14.8343ZM26.3247 27.0218C26.274 27.3072 26.0153 27.566 25.7298 27.6166C25.5569 27.6452 25.3211 27.6724 24.999 27.6729C24.6775 27.6729 24.4417 27.6457 24.2683 27.6166C23.9828 27.566 23.724 27.3072 23.6734 27.0218C23.6448 26.8488 23.6176 26.613 23.6172 26.291C23.6172 25.9694 23.6444 25.7337 23.6734 25.5602C23.724 25.2747 23.9828 25.016 24.2683 24.9654C24.4412 24.9368 24.677 24.9096 24.999 24.9091C25.3206 24.9091 25.5564 24.9363 25.7298 24.9654C26.0153 25.016 26.274 25.2747 26.3247 25.5602C26.3533 25.7332 26.3804 25.969 26.3809 26.291C26.3809 26.6126 26.3537 26.8483 26.3247 27.0218ZM29.1784 19.3441C28.8165 19.856 28.2742 20.3233 27.4717 20.8141C26.4559 21.4404 26.2933 21.6977 26.2933 22.2016V22.4008C26.2933 23.1152 25.712 23.6965 24.9976 23.6965C24.2833 23.6965 23.702 23.1152 23.702 22.4008V21.9391C23.702 21.3447 23.8506 20.8404 24.1562 20.3974C24.4525 19.968 24.8964 19.5865 25.555 19.1951C26.7686 18.4812 26.9908 18.0804 26.9908 17.5483C26.9908 16.8799 26.4212 16.4477 25.5404 16.4477C24.5748 16.4477 23.9462 16.8865 23.672 17.7522C23.4911 18.3232 22.9623 18.7066 22.3567 18.7066C22.3229 18.7066 22.2892 18.7052 22.2554 18.7029C21.8279 18.6719 21.445 18.4502 21.205 18.0944C20.9673 17.7424 20.905 17.3097 21.0339 16.9071C21.3292 15.9865 21.8954 15.2205 22.6712 14.6918C23.4569 14.1565 24.4492 13.8738 25.54 13.8738C26.6308 13.8738 27.7244 14.2352 28.5006 14.8915C29.2994 15.5669 29.7395 16.4979 29.7395 17.5137C29.7395 18.2112 29.5562 18.8102 29.1784 19.3441Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_243_2344"
        x="0.399902"
        y="0.919067"
        width="50"
        height="50"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_243_2344"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_243_2344"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_243_2344">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(12.9995 10)"
        />
      </clipPath>
    </defs>
  </svg>
);
